import React from "react";
import { Link } from "react-router-dom";
import Hero, { Marquee } from "../components/sections/Hero";
import Stats from "../components/sections/Stats";
import About from "../components/sections/About";
import Architecture from "../components/sections/Architecture";
import ProjectCard from "../components/sections/ProjectCard";
import Cta from "../components/sections/Cta";
import Reveal from "../components/chrome/Reveal";
import { projects } from "../data/site";
import { ArrowRight } from "../lib/icons";
import usePageMeta from "../lib/usePageMeta";

const Home = ({ onToggleTheme }) => {
  usePageMeta({
    title: "Ouri Alkada — Senior Software Developer",
    description:
      "Senior software developer building APIs, cloud automation, data platforms and the apps on top of them. C#, .NET, Azure, SQL Server, React, Swift.",
  });

  return (
    <>
      <Hero onToggleTheme={onToggleTheme} />
      <Marquee />

      <section className="section section--tight">
        <div className="shell">
          <Stats />
        </div>
      </section>

      <About />
      <Architecture />

      <section className="section" id="featured">
        <div className="shell">
          <Reveal className="section__head">
            <span className="eyebrow">Selected work</span>
            <h2 className="section__title">
              Things I've <span className="accent-text">built and shipped</span>
            </h2>
            <p className="section__lede">
              A few favourites — hardware, machine learning, games and tooling.
            </p>
          </Reveal>

          <div className="grid grid--3">
            {projects.slice(0, 3).map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>

          <Reveal style={{ marginTop: "2rem" }}>
            <Link className="btn btn--ghost" to="/projects">
              All projects <ArrowRight size={17} />
            </Link>
          </Reveal>
        </div>
      </section>

      <Cta />
    </>
  );
};

export default Home;
